module.exports = __webpack_public_path__ + "cedc977c24f19330e867824d3e956b68.png";